export const SET_OBJECT_TYPES = 'SET_OBJECT_TYPES';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_CITIES = 'SET_CITIES';
export const SET_ADDRESSES = 'SET_ADDRESSES';